/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const handshake_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m20.106 14.601-5.046.965m-.698-6.696-3.39 1.12a1.126 1.126 0 0 1-1.374-.597 1.138 1.138 0 0 1 .517-1.496l3.284-1.652a2.29 2.29 0 0 1 1.82-.105l4.862 1.778M3.87 14.61h2.39l3.434 3.849A1.312 1.312 0 0 0 12 17.6V17m0 0 .171.068a1.619 1.619 0 0 0 2.22-1.502M12 17l-.956-.956m3.348-.478h.478a1.435 1.435 0 0 0 1.148-2.296l-3.07-3.933m1.444 6.229-1.436-1.436m-2.341-6.485-.35-.289a2.053 2.053 0 0 0-1.98-.252l-4.352 1.74M1 7.18h1.956a.94.94 0 0 1 .977.896v6.274a.94.94 0 0 1-.977.897H1m22 0h-1.956a.94.94 0 0 1-.977-.897V8.076a.94.94 0 0 1 .977-.896H23"
    />
  </svg>
)
export default handshake_medium
